<template>
    <el-dialog :visible.sync="show" :title="title" width="800px" :close-on-click-modal="false">
        <!-- 字典名称 -->
        <el-row :span="24" type="flex" align="middle">
            <el-col :span="4" :offset="2" class="d-flex right required">
                字典名称：
            </el-col>
            <el-col :span="16">
                <el-input :disabled="isView" v-model="detail.name" :placeholder="`请输入`"
                    clearable></el-input>
            </el-col>
        </el-row>

        <!-- 字典类型 -->
        <!-- <el-row :span="24" type="flex" align="middle" class="mt20">
            <el-col :span="4" :offset="2" class="d-flex right required">
                字典类型：
            </el-col>
            <el-col :span="16">
                <el-input :disabled="isView" v-model="detail.username" :placeholder="`请输入`"
                    clearable></el-input>
            </el-col>
        </el-row> -->
        <!-- 状态 -->
        <!-- <el-row :span="24" type="flex" align="middle" class="mt20">
            <el-col :span="4" :offset="2" class="d-flex right">
                状态：
            </el-col>
            <el-col :span="16">
                <el-radio-group :disabled="isView" v-model="detail.status">
                    <el-radio :label="1">正常</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-col>
        </el-row> -->
        <!-- 备注 -->
        <el-row :span="24" type="flex" align="middle" class="mt20">
            <el-col :span="4" :offset="2" class="d-flex right">
                备注：
            </el-col>
            <el-col :span="16">
                <el-input class="input250" :placeholder="`请输入`" maxLength="10"
                    v-model="detail.remark"></el-input>
            </el-col>
        </el-row>
        <div slot="footer" class="d-flex right">
            <el-button size="small" @click="close">关闭</el-button>
            <el-button v-show="!isView" size="small" type="primary" @click="save">{{ `确定`
                }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import {
    sysOptionManageUpdate
} from '@/api.js';
export default {
    name: 'DictManagementEdit',
    components: {},
    data() {
        return {
            show: false,
            isView: false,
            detail: {
                id: undefined,
                status: 1,
                role_id: 3,
                is_sms: 0,
                remark: undefined
            },
        }
    },
    computed: {
        ...mapGetters(['user']),
        mode() {
            // 新建或编辑
            const {
                id
            } = this.detail
            let mode = 'new'; // new or edit
            if (id && Number(id)) {
                mode = 'edit'
            } else {
                mode = 'new'
            }

            return mode
        },
        title() {
            let title = ''
            if (this.mode === 'new') {
                title = `新增`
            } else if (this.mode === 'edit') {
                title = `编辑`
            }

            if (this.isView) {
                title = `详情`
            }

            return title
        },
    },
    methods: {
        async open(config = {}) {
            this.reset()
            this.detail = config            
            this.show = true
        },
        reset() {
            this.detail = {
                id: undefined,
                status: 1,
                role_id: 3,
                is_sms: 0
            },
                this.isView = false
        },
        validateFields(params) {
            // 校验字段
            const {
                name,
            } = params

            let msg = '';
            if (!name || !name.trim()) {
                msg = `字典名称不能为空`
            } 

            if (msg) {
                this.$message.error(msg)
            }

            return !msg
        },
        save() {
            // 保存
            const {
                id,
                remark,
                name
            } = this.detail
            const params = {
                name,
                remark
            }
            const validate = this.validateFields(params)
            if (!validate) return

            this.$request('post', sysOptionManageUpdate+`/${id}`, params)
                .then(res => {
                    if (res) {
                        this.$message.success(`操作成功`)
                        this.notifyRefresh()
                        this.close()
                    }
                })
        },
        notifyRefresh() {
            this.$emit('fresh')
        },
        close() {
            this.show = false
        }
    }
}
</script>

<style lang="scss" scoped>
.photo-btn {
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: lightgray;
    border-radius: 4px;
    cursor: pointer;

    i {
        color: #fff;
        font-size: 30px;
        vertical-align: middle;
    }
}

.logo-image {
    height: 60px;
    width: auto;
}

.select-class {
    width: 100%;
}
</style>
<style lang="scss">
.cascader-style {
    height: 30vh;

    .el-cascader-panel {
        height: 100%;
    }
}
</style>